import React from 'react';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import Banner from '../Elements/Banner';
import AboutCompany from '../Elements/AboutCompany';
import Specialization3 from '../Elements/Specialization3';
import AllServices2 from '../Elements/AllServices2';
import OurServices from '../Elements/OurServices';
import AllServices from '../Elements/AllServices';
import AllServices3 from '../Elements/AllServices3';
import OurValue3 from '../Elements/OurValue3';
import OurProject3 from '../Elements/OurProject3';
import Faq from '../Elements/Faq';
import { NavLink } from 'react-router-dom';

var bnrimg = require('./../../images/banner/7.jpg');
var bnr1 = require('./../../images/background/bg-6.png');

class Doradztwo extends React.Component {
    render() {
        return (
            <>

                <Header />
                <div className="page-content">
                    <Banner title="Usługi doradcze i konsultacje " pagename="Usługi" bgimage={bnrimg}/>
                    <div className="section-full p-t80 bg-white">
                    <div className="container">
                        <div className="section-content ">
                            <div className="m-service-containt text-black">
                                <div className="row">
                                    <div className="col-md-5 col-sm-12">
                                        <div className="service-about-left">
                                            <div className="mt-media">
                                                <img src={require('./../../images/services/s1.png')} alt=" A professional meeting scene with a skatepark design expert consulting with local government representatives, ensuring that all figures above the tabl"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-7 col-sm-12">
                                        <div className="service-about-right m-b30">
                                        <h3 className="m-t0">Na każdym etapie inicjatywy niezbędna jest wiedza</h3>
                                        
                                        <p>Sukces inwestycji jaką jest budowa skateparku zależy od umiejętności połączenia wielu czynników projektowych oraz społecznych. Już na wczesnym etapie planowania stajemy przed szeregiem pytań i decyzji do podjęcia, m.in.: budżet, lokalizacja, technologia, projekt. Kluczowe są: dobre zrozumienie z lokalną społecznością odbiorców oraz komplet specjalistycznej wiedzy technicznej oraz praktycznej, której nie zdobędzie się na żadnym uniwersytecie</p>
                                        <p>
                                        Wszyscy członkowie naszego zespołu są wieloletnimi entuzjastami sportów miejskich i posiadają niezbędne doświadczenie i wykształcenie we wszystkich potrzebnych dziedzinach aby oferować kompletne usługi najwyższej jakości.</p>
                                        <p> Dzięki takiemu fundamentowi firmy i indywidualnemu podejściu do klienta potrafimy sprawnie pogodzić lokalne potrzeby społeczności i uwarunkowania ekonomiczne. Skateparki, które tworzymy są nowoczesne, bezpieczne i stają się popularnymi miejscami spotkań i rozwoju lokalnych talentów sportowych.</p>
                                        <p>
                                        Pomagamy w każdej kwestii związanej z rozwojem inicjatyw oddolnych, konsultacjami społecznymi, przygotowaniem do inwestycji, planowaniem, projektowaniem i etapem wykonawczym.</p>
                                                            
                                            <div className="call-for-quote-outer">
                                                <div className="call-quote">
                                                    <span>Jeżeli reprezentujesz samorząd i szukasz niezawodnego partnera, zadzwoń</span>
                                                    <h4 >PL +48 500 073 261</h4>
                                                                    <h4>ENG/PL +48 602 762 478</h4>
                                                </div>
                                                <div className="call-estimate bg-dark">
                                                    <a href={`mailto:biuro@skate-arena.pl?subject=Konsultacje dotyczące projektowania skateparku w [MIEJSCE]&body=${encodeURIComponent("Dzień dobry,\n\nProszę o kontakt w sprawie konsultacji dotyczących projektowania skateparku. Moje dane kontaktowe to:\nTelefon: [Twój numer telefonu]\nPozdrawiam,\n\n[Twoje Imię i Nazwisko]\n[Instytucja]")}`} className="site-button">
                                            lub wyślij do nas email!
                                        </a>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="section-full p-t80 p-b50 bg-dark mobile-page-padding" style={{backgroundImage:"url(" + bnr1 + ")"}}>
                    <div className="container">
                      
                        <div className="section-content">
                            <div className="section-head m-b50 text-white text-center">
                            <h3 className="m-t0">W naszej pracy wykorzystujemy wiedzę ekspercką i doświadczenie.</h3>
                               
                            <p>Jako liderzy w projektowaniu i budowie skateparków, dysponujemy specjalistyczną wiedzą, która pozwala na stworzenie przestrzeni dostosowanych do potrzeb społeczności lokalnych. Nasze projekty są wynikiem dogłębnych konsultacji z samorządami, aby zapewnić, że każda realizacja odzwierciedla oczekiwania i potrzeby mieszkańców. Nasze doświadczenie w branży pozwala na efektywne zarządzanie projektami od koncepcji po realizację, zawsze z zachowaniem najwyższych standardów bezpieczeństwa i funkcjonalności.</p>
                            </div>
                            <div className="row">
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/1.jpg')}  alt=""/>
                                        <div className="figcaption">
                                            <h4>Krok pierwszy</h4>
                                            <p>Zadzwoń do nas lub napisz email.</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-6 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/2.jpg')} alt="" />
                                        <div className="figcaption">
                                            <h4>Krok drugi</h4>
                                            <p>Oparacujemy wstepna koncepcje i umawiamy spotkanie</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-4 col-sm-12 m-b30">
                                    <div className="image-effect-one hover-shadow">
                                        <img src={require('../../images/services/3.jpg')} alt=""/>
                                        <div className="figcaption bg-dark">
                                            <h4>Krok trzeci</h4>
                                            <p>Prezentujemy koncepcję podaczas konsultacji społecznych.</p>
                                            <NavLink to="/project-detail"><i className="link-plus bg-primary" /></NavLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

                    
                 
           
                <Footer />
                    
                </div>

                
               

            </>
        );
    };
};

export default Doradztwo;